export default __webpack_public_path__ + "static/media/UpInTheAir.adb05705.mp3";